/**
 * JOIN — what an invitation link opens onto (phone). 3026, docs/INVITES.md.
 *
 * Bare chrome, like `landing`, `login` and `startCrew`, and for the strongest
 * version of that reason: the reader may have no account AT ALL. A header
 * naming a crew they have not joined, or a bottom nav into screens that assume
 * one, would both be answering a question nobody asked.
 *
 * No mirror exists for this screen — the prototype has no invitation flow —
 * so the frame is the landing screen's and the body is shared with desktop in
 * `components/JoinCard.tsx`. It owes a DESIGN-CHANGELOG entry upstream.
 */

import { JoinCard } from '../components/JoinCard.tsx';
import { QuarterIcon } from '../components/QuarterIcon.tsx';

const M = {
  headFs: '13px',
  bodyFs: '10.5px',
  fieldFs: '12px',
  btnFs: 9,
  pad: '0',
};

export default function Join(): JSX.Element {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '34px 16px 26px',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <QuarterIcon u={2.5} />
        <div
          style={{
            fontFamily: 'var(--gt-font-pixel)',
            fontSize: '17px',
            color: 'var(--gt-text)',
            lineHeight: 1.6,
            marginTop: '16px',
          }}
        >
          GAMES TONIGHT<span style={{ color: 'var(--acc2)' }}>?</span>
        </div>
      </div>

      <div style={{ marginTop: '26px' }}>
        <JoinCard m={M} />
      </div>
    </div>
  );
}
